module.exports = __webpack_public_path__ + "247a516499e823a1b5dca7322efddd02.png";